
<div v-if="listView && entries">
  <list-view-table-meta-links
    :total-count="totalCount"
    :show-view-all="hasMore"
    :showCreateRelatedEntry="showCreateButton"
    @click-view-all="clickViewAll"
    @click-create-related-entry="goToCreateRelatedEntry"
    :show-connected-text="true"
  ></list-view-table-meta-links>
  <list-view-scrollable-table
    :is-in-detail-view-edit-mode="isInEditMode"
    is-embedded
    :list-view="listView"
    :entries="entriesArray"
  ></list-view-scrollable-table>
</div>
